<script>
export default {
  props: {
    google: {
      type: Object,
      required: true,
    },
    map: {
      type: Object,
      required: true,
    },
    position: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      infoWindow: null,
    };
  },

  watch: {
    position() {
      this.infoWindow.setPosition(this.position);
      this.infoWindow.setOptions(this.options);
    },
    options() {
      this.infoWindow.setPosition(this.position);
      this.infoWindow.setOptions(this.options);
    },
  },

  mounted() {
    const { InfoWindow } = this.google.maps;
    this.infoWindow = new InfoWindow({
      position: this.position,
      map: this.map,
      ...this.options,
    });
  },

  render() {},
};
</script>
